import React from 'react';

export function LoadingRing(): React.ReactElement {
  return (
    <div className="progress">
      <div className="loading-ring">
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          className="loading-ring__svg"
          viewBox="25 25 50 50"
        >
          <circle
            className="loading-ring__svg-path"
            cx="50"
            cy="50"
            r="20"
            fill="none"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
        </svg>
      </div>
    </div>
  );
}
